import React, { useState, useEffect, useCallback } from 'react'
import { lang, thDateFormat, addLeadingZeros } from '../lang'
import api from '../api'
import DataTable from 'react-data-table-component';
import FilterComponent from './DetailFilter';
import CancelModal from './CancelModal';
import FieldValue from "../Template/FieldValue";

export default function Table(props) {
    const {styles, menu} = props;
    const [bookings, setBookings] = useState([]);
    const [assistant_bookings, setAssistantBookings] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [listsdata, setListsdata] = useState([]);
    const today = new Date().toISOString().split('T')[0];
    const [select_date, setSelectDate] = useState(today); 
    const [success, setSuccess] = useState(0); 
    const [booking, setBooking] = useState(null);  
    const [cancel_display, setCancelDisplay] = useState(false);  
    const email = localStorage.getItem("email");

    const fetchData = useCallback(async () =>{
        try {
            const response = await api.get('/rsvn?email='+email);
            const results = response.data.results;
            let all_events = [];
            results.forEach(element => {
                let item = {
                    title: lang(element.room_name,element.room_name_en),
                    start  : element.booking_date+'T'+element.start_time+':00',
                    end  : element.booking_date+'T'+element.end_time+':00',
                    item  : element,
                    type  : "booking",
                    allDay : false

                }
                all_events.push(item);
            });
            
            let filteredItems = results.filter((item) => {
                return item.booking_email === email;
            });

            const asst_response = await api.get('/assistant-bookings?email='+email);
            const asst_results = asst_response.data.results;
            asst_results.forEach(element => {
                filteredItems.push({
                    id: element.id,
                    assistant_id: element.assistant_id,
                    room_name: element.assistant_name,
                    booking_date: element.booking_date,
                    start_time: element.start_time.substr(0,5),
                    end_time: element.end_time.substr(0,5),
                    title: "นัดหมายตรวจรายงาน",
                    booking_by: element.booking_by,
                    booking_email: element.booking_email,
                    cancel: element.cancel,
                    cancel_by: element.cancel_by,
                    cancel_time: element.cancel_time,
                    cancel_reason: element.cancel_reason,
                });
            });
            setBookings(filteredItems);
            setListsdata(filteredItems);
        } catch (err) {
            if(err.response){
                //Not in 202 response range
                console.log(err.response.data);
                console.log(err.response.headers);
                console.log(err.response.status);
            } else {
                console.log(`Error: ${err.message}`);
            }
        }
    },[email, assistant_bookings]);
    
    const cols = [
        {
            name: lang('ลำดับ','#'),
            selector: (row, index) =>  Number(index+1),
            center: true,
            width: '90px',
        },
        {
            name: lang('ห้อง','Rooms'),
            selector: row => <FieldValue value={row.room_name} keyword={filterText}/>,
            center: true,
            sortable: false,
        },
        {
            name: lang('วันที่','Date'),
            selector: row => <FieldValue value={thDateFormat(row.booking_date)} keyword={filterText}/>,
            center: true,
            sortable: false,
        },
        {
            name: lang('เวลา','Time'),
            selector: row => <FieldValue value={row.start_time+'-'+row.end_time} keyword={filterText}/>,
            center: true,
            sortable: false,
        },
        {
            name: lang('รายละเอียด','Detail'),
            selector: row => <FieldValue value={row.title} keyword={filterText}/>,
            sortable: false,
        },
        {
            name: lang('ผู้จอง','Booking By'),
            selector: row => <FieldValue value={row.booking_by} keyword={filterText}/>,
            sortable: false,
            wrap: true, 
        },
        {
            name: lang('ยกเลิกการจอง','Cancel Booking'),
            selector: row => (parseInt(row.cancel)===0) ? (
                canCancel(row) ? <span className="a-links" onClick={()=>{cancelBooking(row)}}>{lang('ยกเลิกการจอง','Cancel Booking')}</span> : <span>-</span>
            ) : (
                <small className="a-links" onClick={()=>{cancelBooking(row)}}>{lang('ยกเลิกโดย ','Cancel By ')}<br/>{row.cancel_by}<br/>({row.cancel_time})</small>
            ),
            center: true,
            sortable: false,
        },
    ];

    useEffect(()=>{
        if(!email){
            window.location = process.env.PUBLIC_URL + '/rsvn?menu=login';
        }

        // console.log(select_date)
        fetchData();
    },[menu,email,fetchData]);

    const onFilter = (txt) => {  
        // console.log(equipments_data)
        let filteredItems = bookings.filter(
            item => {
                return item.id.includes(txt.toLowerCase()) || 
                        (item.start_time+'-'+item.end_time).includes(txt.toLowerCase()) || 
                        item.room_name.toLowerCase().includes(txt.toLowerCase()) || 
                        item.title.toLowerCase().includes(txt.toLowerCase()) || 
                        thDateFormat(item.booking_date).includes(txt.toLowerCase()) || 
                        item.booking_by.toLowerCase().includes(txt.toLowerCase());
            }
        );
        setListsdata(filteredItems);
        setFilterText(txt);
    }

    /* filter and clearfilter */
    const handleClear = () => {
        const txt = '';
        let filteredItems = bookings.filter(
            item => {
                return item.id.includes(txt.toLowerCase()) || 
                        (item.start_time+'-'+item.end_time).includes(txt.toLowerCase()) || 
                        item.room_name.toLowerCase().includes(txt.toLowerCase()) || 
                        item.title.toLowerCase().includes(txt.toLowerCase()) || 
                        thDateFormat(item.booking_date).includes(txt.toLowerCase()) || 
                        item.booking_by.toLowerCase().includes(txt.toLowerCase());
            }
        );
        setListsdata(filteredItems);
        setFilterText('');
    };

    const onSelectDate = (value) => {
        setFilterText('');
        setSelectDate(value);
    }

    const cancelBooking = (row) => {
        setBooking(row);
        setCancelDisplay(true);
    }

    const onSuccess = () => {
        setSuccess(1);
        fetchData();
    }

    // Helper to determine if a booking can be cancelled.
    // options: { unit: 'minutes'|'hour'|'day', value: number }
    // also supports shortcuts: 'hour' => 1 hour, 'day' => 1 day, 'short' => 15 minutes
    const canCancel = (row, options = { unit: 'hour', value: 1 }) => {
        if(!row || !row.booking_date || !row.start_time) return false;

        // interpret shortcuts
        let unit = options.unit || 'hour';
        let value = options.value || 1;
        if(typeof options === 'string'){
            if(options === 'hour') { unit = 'hour'; value = 1 }
            else if(options === 'day') { unit = 'day'; value = 1 }
            else if(options === 'short') { unit = 'minutes'; value = 15 }
        }

        // compute booking start datetime
        const startIso = `${row.booking_date}T${row.start_time}:00`;
        const startDate = new Date(startIso);
        if(isNaN(startDate.getTime())) return false;

        const now = new Date();
        let cutoff = new Date(now.getTime());
        if(unit === 'day') cutoff.setDate(cutoff.getDate() + value);
        else if(unit === 'hour') cutoff.setHours(cutoff.getHours() + value);
        else cutoff.setMinutes(cutoff.getMinutes() + value);

        return startDate > cutoff;
    }

  return (
    <div>
        <div className={`${styles["black-screen"]} ${(cancel_display)?'':'hidden'}`}>
            <CancelModal display={cancel_display} setDisplay={setCancelDisplay} booking={booking} setBooking={setBooking} fetchData={fetchData} setSuccess={setSuccess} styles={styles} onSuccess={onSuccess} />
        </div>
        <h3>{lang("การจองของฉัน","My Booking")}</h3>
        <div className={styles["full-detail"]}>
            {(success===1)?(
            <div className="notice active mt-2">
                <div><i className="fa-regular fa-file-lines"></i></div>
                <div className="info">
                    <b>{lang('บันทึกข้อมูลเรียบร้อย!','Successfuly!')}</b>
                    <p>{lang('ทำรายการบันทึกข้อมูลเรียบร้อย','Complete update data!')}..</p>
                </div>
                <div>
                    <i className="fa-solid fa-xmark btn-close" onClick={(event)=>setSuccess(0)}></i>
                </div>
            </div>
            ):''}
            <DataTable 
                columns={cols} 
                data={listsdata} 
                pagination 
                paginationComponentOptions={ {rowsPerPageText: lang('แสดงข้อมูลแถว:','Total Row:'), rangeSeparatorText:  lang('จาก','to'), noRowsPerPage: false, selectAllRowsItem: true, selectAllRowsItemText: lang('แสดงทั้งหมด','All Rows') }}
                subHeader
                striped
                subHeaderComponent={<FilterComponent selectDate={select_date} setSelectDate={e => onSelectDate(e.target.value)} onFilter={e => onFilter(e.target.value)} onClear={handleClear} filterText={filterText} export={false}/>}
                paginationPerPage={10} />
            </div>
    </div>
  )
}
